export function PartyCamera({
  onOpen,
  onRecover,
  message,
}: {
  onOpen: () => void;
  onRecover: () => void;
  message: string;
}) {
  return (
    <>
      <p className="eyebrow">The Celebration · Camera</p>
      <h2>Let’s get your photo.</h2>
      <p role="status">
        {message ||
          'The camera didn’t return a photo. You can try again or choose it if it was saved on your phone.'}
      </p>
      <button className="button full-width" onClick={onOpen}>
        Open camera
      </button>
      <button className="secondary-button full-width" onClick={onRecover}>
        Choose saved photo
      </button>
      <p className="fine-print">
        Accept your photo to return here, add your name and a message, then share it.
      </p>
    </>
  );
}
